import { cn } from "@/lib/utils";
import { format, isSameDay, isToday, isYesterday } from "date-fns";
import { arSA, enUS } from "date-fns/locale";
import { useLocale, useTranslations } from "next-intl";
import React, { memo } from "react";

const ChatDivider = ({
  currentMsgId,
  prevMsgId: nextMsgId,
}: {
  currentMsgId: number;
  prevMsgId: number;
}) => {
  const t = useTranslations();
  const locale = useLocale();
  return (
    currentMsgId && (
      <div
        className={cn("divider", {
          hidden: isSameDay(new Date(currentMsgId), new Date(nextMsgId)),
        })}
      >
        {isToday(new Date(currentMsgId))
          ? t("host.today")
          : isYesterday(new Date(currentMsgId))
          ? t("host.yesterday")
          : format(new Date(currentMsgId), "dd LLLL y", {
              locale: locale === "ar" ? arSA : enUS,
            })}
      </div>
    )
  );
};

export default memo(ChatDivider);
